import React from 'react';

export default function SearchIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ?? '24'}
      height={props.height ?? '24'}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.565 5.5C9.56324 5.5 8.58397 5.79706 7.75104 6.35361C6.9181 6.91016 6.26891 7.7012 5.88555 8.62671C5.5022 9.55222 5.40189 10.5706 5.59733 11.5531C5.79276 12.5356 6.27515 13.4381 6.98351 14.1465C7.69186 14.8548 8.59436 15.3372 9.57687 15.5327C10.5594 15.7281 11.5778 15.6278 12.5033 15.2445C13.4288 14.8611 14.2198 14.2119 14.7764 13.379C15.3329 12.546 15.63 11.5668 15.63 10.565C15.63 9.22168 15.0964 7.93338 14.1465 6.9835C13.1966 6.03363 11.9083 5.5 10.565 5.5ZM6.91768 5.1064C7.99729 4.38503 9.26657 4 10.565 4C12.3061 4 13.976 4.69167 15.2072 5.92284C16.4383 7.15402 17.13 8.82385 17.13 10.565C17.13 11.8634 16.745 13.1327 16.0236 14.2123C15.3022 15.2919 14.2769 16.1334 13.0773 16.6303C11.8777 17.1272 10.5577 17.2572 9.28423 17.0039C8.01075 16.7505 6.84098 16.1253 5.92285 15.2072C5.00472 14.289 4.37946 13.1193 4.12615 11.8458C3.87284 10.5723 4.00284 9.25228 4.49973 8.05268C4.99662 6.85309 5.83808 5.82777 6.91768 5.1064Z"
        fill={props.fill ?? '#1A1A1A'}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.1415 14.1418C14.4344 13.8489 14.9093 13.8489 15.2022 14.1418L20.4022 19.3418C20.6951 19.6347 20.6951 20.1096 20.4022 20.4024C20.1093 20.6953 19.6344 20.6953 19.3415 20.4024L14.1415 15.2024C13.8487 14.9096 13.8487 14.4347 14.1415 14.1418Z"
        fill={props.fill ?? '#1A1A1A'}
      />
    </svg>
  );
}
